import ApplicationController from './application_controller';

/**
 * Shows the time delay radio options only while the electronic claim submission setting is "delay".
 *
 * @controller claim-submission-delay
 * @example please look at organizations/edit_partials/_emr_settings_body.html.erb.
 */
export default class extends ApplicationController {
  static targets = ['select', 'delayOptions'];

  toggle() {
    this.delayOptionsTarget.hidden = this.selectTarget.value !== 'delay';
  }
}
